module.exports = __webpack_public_path__ + "img/practice-4.05af6888.jpg";